import XEUtils from 'xe-utils'
import {reportYear,metaData} from '../../util/util'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
Vue.use('vxe-utils');
Vue.use('vxe-table');
const region_dict = {
  "520000": "贵州",
  "540000": "西藏",
  "530000": "云南",
  "500000": "重庆",
  "360000": "江西",
  "340000": "安徽",
  "510000": "四川",
  "350000": "福建",
  "430000": "湖南",
  "420000": "湖北",
  "410000": "河南",
  "330000": "浙江",
  "640000": "宁夏",
  "650000": "新疆",
  "440000": "广东",
  "370000": "山东",
  "450000": "广西",
  "630000": "青海",
  "320000": "江苏",
  "140000": "山西",
  "460000": "海南",
  "310000": "上海",
  "110000": "北京",
  "130000": "河北",
  "230000": "黑龙江",
  "220000": "吉林",
  "210000": "辽宁",
  "150000": "内蒙古",
  "120000": "天津",
  "620000": "甘肃",
  "610000": "四川",
  "710000": "台湾",
  "810000": "香港",
  "820000": "澳门"
}
const reportRaw=reportYear.report_years
let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      entityCount: 0,
      loading: false,
      follow_entity_customer: false,
      follow_entity_supplier: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pagerCount: 3,
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true
      },
      data: [],
      exportConfig: {},
      product_type: null,
      supplier_oaid: null,
      customer_oaid: null,
      customer_region: null,
      supplier_region: null,
      duration: 5,
      report: reportYear.report_year_now,
      reports: reportYear.report_options,
      product_types: [],
      regionoptions: [],
      tableColumn: [
        {type: 'seq', width: 50},
        {title: 'i18n.supplychain.supplier_name', field: "supplier_name", className: "click-cell-style"},
        {title: 'i18n.supplychain.supplier_security_code', field: "ticker_s", type:"html", className: "click-cell-style",
          formatter: ({ cellValue })=>{
            let result = []
            let as = cellValue.split(',')
              for(let a in as){
                if(as[a])
                  result.push('<a target="_blank" href="/entity/'+as[a]+'/home">'+as[a]+'</a>')
              }
            return result.join('</br>')
          }
        },
        {title: 'i18n.supplychain.supplier_region', field: "region_s", formatter: ({ cellValue })=>{let k = cellValue ? cellValue.substring(0,2)+"0000":"";return k in region_dict? region_dict[k]:"其他"}},
        {title: 'i18n.supplychain.customer_name', field: "customer_name", className: "click-cell-style"},
        {title: 'i18n.supplychain.customer_security_code', field: "ticker_c", type:"html", className: "click-cell-style",
          formatter: ({ cellValue })=>{
            let result = []
            let as = cellValue.split(',')
              for(let a in as){
                if(as[a])
                  result.push('<a target="_blank" style="color: inherit" href="/entity/'+as[a]+'/home">'+as[a]+'</a>')
              }
            return result.join('</br>')
          }
        },
        {title: 'i18n.supplychain.customer_region', field: "region_c", formatter: ({ cellValue })=>{let k = cellValue ? cellValue.substring(0,2)+"0000":"";return k in region_dict? region_dict[k]:"其他"}},
        {title: 'i18n.common.report_period', field: "reporting_period"},
        {title: 'i18n.supplychain.product', field: "product"},
        {title: 'i18n.supplychain.money', field: "amount_cny", formatter: ({ cellValue })=>{return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}}
      ]
    }
  },
  methods: {
    openDataExport () {
      let s = "TOP供应链"
      this.$refs.xTable_data.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv']
      })
    },
    trans_regions () {
      this.regionoptions = []
      this.regionoptions.push({ label: '全部', value: null })
      for (let k in region_dict) {
        this.regionoptions.push({ label: region_dict[k], value: k })
      }
    },
    productOnChange (value, selectedOptions) {
      this.product_type = value.join('-')
    },
    productFilter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getSCProductData()
    },
    cellClickEvent ({ row, column }) {
      console.log(row,column);
      if (column.property == "supplier_name") {
        if(row.oa_id_s){
          const {
            href
          } = this.$router.resolve({ path: '/entity/' + row.oa_id_s + '/home' })
          window.open(href, '_blank')
        }else{
          alert('该公司信息不存在！')
        }
      }
      if (column.property == "customer_name") {
        if(row.oa_id_c){
          const {
            href
          } = this.$router.resolve({ path: '/entity/' + row.oa_id_c + '/home' })
          window.open(href, '_blank')
        }else{
          alert('该公司信息不存在！')
        }
      }
    },

    generateProductType () {
      let self = this
      metaData.product_type().then(result => {
        self.product_types = result
      })
    },
    getSCProductData () {
      let self = this
      self.loading = true
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      if (self.supplier_oaid)
        params.set("supplier_oaid", self.supplier_oaid)
      if (self.supplier_region)
        params.set("supplier_region", self.supplier_region)
      if (self.customer_oaid)
        params.set("customer_oaid", self.customer_oaid)
      if (self.customer_region)
        params.set("customer_region", self.customer_region)
      let reports = reportYear.getReport(self.report, self.duration)
      params.set('reports', reports)
      if (self.product_type)
        params.set('product_type', self.product_type)
      params.set("follow_entity_supplier", self.follow_entity_supplier)
      params.set("follow_entity_customer", self.follow_entity_customer)
      httpManager("sc_product_table", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          let page = response.data.page
          self.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
  },
  mounted() {
    this.trans_regions()
    this.generateProductType()
    this.getSCProductData()
  },

  watch: {
    customer_region: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    customer_oaid: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    supplier_region: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    supplier_oaid: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    report: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    duration: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    product_type: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    follow_entity_supplier: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
    follow_entity_customer: function () {
      this.page.currentPage = 1
      this.getSCProductData()
    },
  },
  created(){
  }
}
Vue.component("sc-product-table", vm)
export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/sc_product_table.js